export enum DestinationType {
    España,
    Portugal,
    Otro
}
